export type ToastsTranslations = {
  cannotCreateCycle: string;
  continueFailed: string;
  errorResolved: string;
  errorResolveFailed: string;
  errorsResolved: string;
  errorsResolveFailed: string;
  fetch: {
    error: string;
    success: string;
  };
  fileReplaceFailed: string;
  fileReplaceSuccess: string;
  fileTypeRequired: string;
  resolveAllErrors: string;
  upload: {
    fileError: string;
    generalError: string;
  };
  uploadContinued: string;
};

export const toastsTranslations: ToastsTranslations = {
  cannotCreateCycle: 'Nie można utworzyć ścieżki dla tego pracownika.',
  continueFailed: 'Nie udało się kontynuować importu',
  errorResolved: 'Błąd rozwiązany',
  errorResolveFailed: 'Nie udało się rozwiązać błędu',
  errorsResolved: 'Błędy rozwiązane',
  errorsResolveFailed: 'Nie udało się rozwiązać błędów',
  fetch: {
    error: 'Wystapił błąd. Spróbuj ponownie lub zgłoś błąd',
    success: 'Działanie zakończone sukcesem',
  },
  fileReplaceFailed: 'Nie udało się podmienić pliku',
  fileReplaceSuccess: 'Plik został pomyślnie podmieniony. Walidacja rozpocznie się od nowa.',
  fileTypeRequired: 'Wymagany jest typ pliku. Wybierz odpowiedni typ pliku przed przesłaniem.',
  resolveAllErrors: 'Proszę rozwiązać wszystkie błędy przed kontynuacją',
  upload: {
    fileError:
      'Wystąpił błąd podczas przesyłania pliku. Sprawdź poprawność pliku i spróbuj ponownie.',
    generalError: 'Wystąpił błąd podczas przesyłania danych. Spróbuj ponownie później.',
  },
  uploadContinued: 'Import wznowiony pomyślnie',
};
